module.exports = __webpack_public_path__ + "img/whatsapp_w.f6fd992e.svg";